$(function () {
	$(".date-picker").each(function () {
		InitializeDatePicker($(this));
	});
});

var defaultDateTimePickerOptions = {
	format: "M/D/YYYY h:mm a",
	icons: {
		date: "novicon novicon-calendar",
		time: "novicon novicon-time",
		up: "fas fa-chevron-up",
		down: "fas fa-chevron-down",
		previous: "fas fa-chevron-left",
		next: "fas fa-chevron-right",
		close: "fas fa-times"
	},
	keyBinds: {
		left: null,
		right: null
	},
	useCurrent: false,
	showClose: true,
	minDate: "1/1/1800",
    maxDate: false
};

function InitializeDatePicker(element) {
	var options = $.extend({}, defaultDateTimePickerOptions, {});
	options.format = element.data("only-time") ? "LT" : element.data("include-time") ? "M/D/YYYY h:mm a" : "l";

    // We're forcing the formatting of the date before being attached to the date-picker 
    // otherwise the date-picker will clear the value if it's not formatted correctly.
    var dateMoment;
    if (element) {
        dateMoment = moment(element.val());
        if (dateMoment.isValid()) {
		  element.val(dateMoment.format(options.format));
        }
    }

	options.showClose = !element.data("only-time") && element.data("include-time");

    options.widgetPositioning = {
        horizontal: 'auto',
        // If being shown in a modal, position the picker beneath the related element ('bottom')
        // to prevent it from floating above the top of the visible frame.
        vertical: $('body').hasClass('in-modal') || $('#census-page').length || element.data("is-bottom") ? 'bottom' : 'auto'
    };

	if (element.data("min-date"))
		options.minDate = element.data("min-date");
	if (element.data("max-date"))
        options.maxDate = element.data("max-date");    

    PlaceCalendarIcon(element);

    element.datetimepicker(options);
}

function PlaceCalendarIcon(element) {
    if (element.data("with-icon")) {
        element.parent().css('position', 'relative');

        var next = element.next();
        var position = element.position();
        var top = position.top + (parseInt(element.css('marginTop')) || 0) + 6;
        var left = position.left + element.width() + (parseInt(element.css('marginLeft')) || 0) - 5;

        if (next.length === 0 || !next.hasClass("novicon-calendar")) {
            element.after($("<span class='novicon novicon-calendar'></span>").css({
                "position": "absolute",
                "pointer-events": "none",
                "font-size": "20px",
                "left": left + "px",
                "top": top + "px"
            }));
        }
        else {
            next.css('left', left + 'px');
            next.css('top', top + 'px');
        }
    }
}